import * as React from 'react';
import PropTypes from 'prop-types';
import Toolbar from '@mui/material/Toolbar';
import { Outlet } from 'react-router-dom';
import { Container } from '@mui/system';
import NavGuest from './guest/NavGuest';

function GuestTemplate(props) {

    return (
        <Container>
            {/* <NavGuest setMode={props.setMode} mode={props.mode} />
            <Toolbar /> */}

            <Outlet />
        </Container>
    );
}

GuestTemplate.propTypes = {
    window: PropTypes.func,
};

export default GuestTemplate;
